import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export class AssessmentExpired extends React.Component<RouteComponentProps<{}>> {
    render() {
        return (
            <div className="Survey">
                <div className="bgBase" />
                <div className="bg" />
                <div className="bg2" />
                <div className="content">
                    <div className="container">
                        <div className="survey-finished">
                            <h1><strong>The requested assessment has expired</strong></h1>
                            <br />
                            <h1>Please contact Pondera Leadership Consulting for assistance.</h1>
                        </div>
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/assessment/AssessmentExpired.tsx